export function useLocalized() {
    // `useI18n()` throws when there is no active i18n context (e.g. a component
    // instance created outside the normal setup flow). Without this guard the
    // @Setup() callback dies and `localized` stays undefined on the component,
    // which later crashes with "this.localized is not a function".
    let locale
    try {
        locale = useI18n().locale
    } catch {
        locale = {value: 'en'}
    }

    return (localizable: string | object, localeKey?: string) =>
        typeof localizable === 'string'
            ? localizable || ''
            : localizable?.[localeKey] ||
              localizable?.[locale.value] ||
              localizable?.[Object.keys(localizable)[0]] ||
              ''
}
